/**
 * Tenant roadmaps list at /tenant/roadmaps — saved roadmaps only.
 * AI planning lives at /tenant/planning (PlanningPage).
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';
import { MapIcon, PlusIcon } from '@heroicons/react/24/outline';
import { TenantRoadmapsPage } from './TenantRoadmapsPage';

export const RoadmapsPage: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--color-secondary-bg)]">
      <div className="container mx-auto px-2 py-2">
        <div className="p-4 border border-[var(--color-border)] rounded-lg bg-[var(--color-surface-bg)]">
          <div className="mb-2 flex-shrink-0">
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2">
                <MapIcon className="w-5 h-5 text-[var(--color-accent-bg)]" />
                <h1 className="text-xl font-bold text-[var(--color-surface-text)]">{t('roadmap.page.title')}</h1>
              </div>
              <button
                type="button"
                onClick={() => navigate('/tenant/roadmaps/builder')}
                className="inline-flex items-center justify-center px-4 py-2 bg-[var(--color-accent-bg)] text-[var(--color-accent-text)] text-sm font-medium rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
              >
                <PlusIcon className="h-4 w-4 mr-2" />
                {t('common.create')}
              </button>
            </div>
            <p className="text-xs text-[var(--color-secondary-text)] ml-7">{t('roadmap.page.subtitle')}</p>
          </div>

          <div className="mt-6">
            <TenantRoadmapsPage />
          </div>
        </div>
      </div>
    </div>
  );
};
